// extracted by mini-css-extract-plugin
export var collapsedSummary = "_jm-0";